import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { injectGlobal } from "styled-components"
import LoadingOverlay from "molecules/LoadingOverlay"
import WebPlayerWrapper from "organisms/WebPlayerWrapper"
import WebPlayer from "organisms/WebPlayer"
import Api from "services/api"
import Analytics from "utils/analytics"

injectGlobal`
    @import url('https://fonts.googleapis.com/css?family=Lato:300,400,700');

    body {
        margin: 0;
    }
`
const VARIANTS = ["minimal", "small", "mediumLeft", "mediumRight", "largeBottom", "largeTop"]

const filterObject = (obj) => {
  const ret = {}
  Object.keys(obj)
    .filter((key) => obj[key] !== undefined)
    .forEach((key) => {
      ret[key] = obj[key]
    })
  return ret
}


class App extends Component {
  constructor({
    ...settings
  }) {
    super()

    this.state = {
      ...settings,
      configLoaded: false,
    }

    this.api = null
  }

  componentDidMount() {
    const {
      appKey, analytics, publication, ...restHardSettings
    } = this.state
    this.api = new Api(appKey, analytics)

    this.api.getPlayerConfig(publication).then((settings) => {
      const { design, ...restBasicSettings } = settings

      if (design) {
        const { hideSharingButton, ...restDesignSettings = {} } = design

        this.setState({
          ...restBasicSettings,
          ...restDesignSettings,
          share: !hideSharingButton,
          ...filterObject(restHardSettings),
          configLoaded: true,
        })
      } else {
        this.setState({
          ...restBasicSettings,
          ...filterObject(restHardSettings),
          configLoaded: true,
        })
      }
    })
  }

  getAnalytics = () => this.props.analytics || new Analytics(this.props.appKey, this.props.publication)

  handleVariantChange = (event) => {
    this.setState({
      variant: event.target.value,
    })
  }

  handleThemeChange = (event) => {
    this.setState({
      theme: event.target.value,
    })
  }

  handleShareChange = (event) => {
    this.setState({
      share: event.target.value === "true",
    })
  }

  handleShareThemeChange = (event) => {
    this.setState({
      shareTheme: event.target.value,
    })
  }

  renderDevControls() {
    if (process.env.NODE_ENV === "development") {
      return (
        <div
          style={{
            padding: 10,
            background: "#fff",
            position: "fixed",
            top: 0,
            right: 0,
          }}
        >
          <label htmlFor='#variant'>Variant</label>
          <select id='variant' onChange={this.handleVariantChange}>
            {VARIANTS.map((variant) => (
              <option key={variant} value={variant}>
                {variant}
              </option>
            ))}
          </select>
          <label htmlFor='#theme'>Theme</label>
          <select id='theme' onChange={this.handleThemeChange}>
            <option value='light'>light</option>
            <option value='dark'>dark</option>
          </select>
          <label htmlFor='#share'>Share</label>
          <select id='share' onChange={this.handleShareChange}>
            <option value='true'>share</option>
            <option value={false}>no share</option>
          </select>
          <label htmlFor='#shareTheme'>Share Theme</label>
          <select id='shareTheme' onChange={this.handleShareThemeChange}>
            <option value='coloured'>coloured</option>
            <option value='inherit'>inherit</option>
          </select>
        </div>
      )
    }

    return null
  }

  render() {
    const {
      autoplay, playlist, publication, configLoaded, iframe, type, border, share, theme, variant, shareTheme, hideWhenEmpty,
    } = this.state

    if (!configLoaded) {
      if (!hideWhenEmpty) {
        return (
          <div style={{ position: "relative" }}>
            <LoadingOverlay />
          </div>
        )
      }
      return <div />
    }

    return (
      <Fragment>
        {this.renderDevControls()}
        <WebPlayerWrapper type={type} iframe={Boolean(iframe)}>
          <WebPlayer
            variant={variant}
            type={type}
            border={border}
            api={this.api}
            analytics={this.getAnalytics()}
            autoplay={autoplay}
            playlist={playlist}
            publication={publication}
            share={Boolean(share)}
            theme={theme}
            shareTheme={shareTheme}
            onTrackChange={this.props.onTrackChange}
            onAudioStart={this.props.onAudioStart}
            hideWhenEmpty={hideWhenEmpty}
            continueWithPublicationPlaylist={this.props.continueWithPublicationPlaylist}
          />
        </WebPlayerWrapper>
      </Fragment>
    )
  }
}

App.propTypes = {
  appKey: PropTypes.string,
  analytics: PropTypes.object,
  publication: PropTypes.string.isRequired,
  playlist: PropTypes.string,
  autoplay: PropTypes.bool,
  iframe: PropTypes.any,
  type: PropTypes.oneOf(["fixed", "inline"]),
  variant: PropTypes.oneOf(["minimal", "small", "mediumLeft", "mediumRight", "largeBottom", "largeTop"]),
  border: PropTypes.bool,
  share: PropTypes.bool,
  theme: PropTypes.oneOf(["light", "dark"]),
  shareTheme: PropTypes.oneOf(["coloured", "inherit"]),
  onTrackChange: PropTypes.func,
  onAudioStart: PropTypes.func,
  hideWhenEmpty: PropTypes.bool,
  continueWithPublicationPlaylist: PropTypes.bool,
}

App.defaultProps = {
  appKey: "default",
}

export default App



// WEBPACK FOOTER //
// ./src/App.js